var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import ObjectHelper from "../helper/ObjectHelper.js";
import StringHelper from "../helper/StringHelper.js";
import Base from "../Base.js";
const { defineProperty } = Object, fencibleSymbol = Symbol("fencible"), NONE = [], distinct = (array) => Array.from(new Set(array)), parseNames = (names) => names ? distinct(StringHelper.split(names)) : NONE;
var Fencible_default = (Target) => {
  var _a;
  return _a = class extends (Target || Base) {
    static setupFenced(cls, meta) {
      const { fenced } = cls, methods = meta.getInherited("fenced");
      let all, any, lock, methodName, options;
      for (methodName in fenced) {
        options = fenced[methodName];
        if (options === true) {
          options = methodName;
        }
        if (!ObjectHelper.isObject(options)) {
          options = {
            all: options
          };
        }
        all = parseNames(options.all);
        any = parseNames(options.any);
        lock = options.lock ? parseNames(options.lock) : distinct(all.concat(any));
        any = any.length ? any : null;
        methods[methodName] = { any, all, lock };
      }
    }
    construct(...args) {
      const me = this, proto = Object.getPrototypeOf(me), fenced = me.$meta.getInherited("fenced"), fences = me[fencibleSymbol] = {}, isFree = (key) => !fences[key];
      ObjectHelper.forEach(fenced, ({ any, all, lock }, name) => {
        defineProperty(me, name, {
          configurable: true,
          value(...params) {
            if (all.every(isFree) && (!any || any.some(isFree))) {
              let key;
              try {
                for (key of lock) {
                  fences[key] = (fences[key] || 0) + 1;
                }
                return proto[name].apply(me, params);
              } finally {
                for (key of lock) {
                  --fences[key];
                }
              }
            }
          }
        });
      });
      return super.construct(...args);
    }
    // This does not need a className on Widgets.
    // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
    // to the Widget it's mixed in to should implement this.
    get widgetClass() {
    }
  }, __publicField(_a, "$name", "Fencible"), __publicField(_a, "declarable", [
    /**
     * This class property returns an object that specifies the instance methods which need reentrancy protection.
     *
     * It is used like so:
     * ```javascript
     *  class Foo extends Base.mixin(Fencible) {
     *      static fenced = {
     *          reentrantMethod : true
     *      };
     *
     *      reentrantMethod() {
     *          // things() may cause reentrantMethod() to be called...
     *          // but we won't be allowed to reenter this method since we are already inside it
     *          this.things();
     *      }
     *  }
     * ```
     *
     * This can also be used to protect mutually reentrant method groups:
     *
     * ```javascript
     *  class Foo extends Base.mixin(Fencible) {
     *      static fenced = {
     *          foo : 'foobar'
     *          bar : 'foobar'
     *      };
     *
     *      foo() {
     *          console.log('foo');
     *          this.bar();
     *      }
     *
     *      bar() {
     *          console.log('bar');
     *          this.foo();
     *      }
     *  }
     *
     *  instance = new Foo();
     *  instance.foo();
     *  >> foo
     *  instance.bar();
     *  >> bar
     * ```
     *
     * The value for a fenced method value can be `true`, a string, an array of strings, or a
     * {@link #typedef-MethodFence} options object.
     *
     * Internally these methods are protected by defining a wrapper function on the instance. The class methods
     * remain on the class prototype and are guarded by the instance-level method. This allows these methods to use
     * `super` calls, just like other methods.
     *
     * @static
     * @member {Object} fenced
     * @internal
     */
    "fenced"
  ]), _a;
};
export {
  Fencible_default as default
};
